import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment';
import { ProductsService } from '../../../../services';
import { AgentProfileComponent } from '../../../agents/agent-profile/agent-profile.component';
import { DiscountRequestApi } from '../../../../../assets/js/lb-sdk/services/custom/DiscountRequest';
import { DiscountRequestFormComponent } from './discount-request-form/discount-request-form.component';
import { PAYMENT_TYPE, USER_ROLES } from '../../../../enums';
import { LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Event } from '../../../../interfaces';

@Component({
  selector: 'app-discount-requests',
  templateUrl: './discount-requests.component.html',
  styleUrls: ['./discount-requests.component.css']
})
export class DiscountRequestsComponent extends BasicList {
  USER_ROLES : typeof USER_ROLES = USER_ROLES;
  moment = moment;

  constructor(
    private discountRequestApi: DiscountRequestApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private loopBackAuth: LoopBackAuth,
    private hasRolePipe: HasRolePipe,
    private toast: ToastrService
  ) {
    super();
    if (this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.ALTERNATIVE_CHANNEL)) {
      this.params = {
        where: { requestor: this.getUser().id }
      };
    } else if (this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.BDM)) {
      this.params = {
        include: 'user'
      };
    }
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'partnerId', placeholder: 'Merchant id', exact: true },
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'paymentType', placeholder: 'Payment Type', options: PAYMENT_TYPE },
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: DiscountRequestFormComponent,
      api: this.discountRequestApi,
      ModalService: this.modalService
    };
  }

  approve(request) {
    this.loading.approval = true;
    this.clearErrors();
    this.discountRequestApi
      .approve(request.id)
      .pipe(finalize(() => {
        this.loading.approval = false;
      }))
      .subscribe((response: any) => {
        this.toast.success('Request Approved!');
        this.getList();
      }, error => {
        this.errors.approval = error.message;
      });
  }

  modify(data) {
    const { creditTerms, endDate, partnerId, merchantType, paymentType, productType, rate, unit, id } = data;
    const endDateMoment = moment(endDate).toDate();
    this.edit({
      id,
      creditTerms,
      endDate: { date: {
        year: endDateMoment.getFullYear(),
        month: endDateMoment.getMonth() + 1,
        day: endDateMoment.getDate()
      } },
      partnerId,
      merchantType: merchantType,
      paymentType: paymentType,
      productType: this.productsService.getProductTypeByName(productType),
      rate,
      unit
    });
  }

  userDetails(data): void {
    const userModal = this.settings.ModalService
      .show(AgentProfileComponent, {
        initialState: { data: { merchantId: data.partnerId } }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (userModal.content) {
          if (userModal.content.result) {
            // DO SOMETHING
          } else {
            // DO SOMETHING
          }
        }
        subscription.unsubscribe();
      });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Discount rate request submitted for BDM approval', 'Discount Rate');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Discount rate request successfully updated', 'Discount Rate');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Discount rate request cancelled', 'Discount Rate');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
